import { render, staticRenderFns } from "./productService.vue?vue&type=template&id=11cd39cc&scoped=true"
import script from "./productService.vue?vue&type=script&lang=js"
export * from "./productService.vue?vue&type=script&lang=js"
import style0 from "./productService.vue?vue&type=style&index=0&id=11cd39cc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11cd39cc",
  null
  
)

export default component.exports